import React, { useCallback } from "react";

import { showDialogAsync } from "../../dialog-queue";

import { PhotoStoreSelection, PhotoSourceDialogContainer } from "./photo-source-dialog-container";

/** Show the dialog with all available photo sources, return the selected photos + used photo source */
const showPhotoSourceDialogAsync = () =>
	showDialogAsync<PhotoStoreSelection | undefined>(
		({ resolve }, { isOpen }) => (
			<PhotoSourceDialogContainer isOpen={isOpen} onClose={resolve} />
		),
		{
			allowOther: true,
		},
	);

// Hook used to fetch dependencies
export function usePhotoSourceDialogAsync() {
	return useCallback(() => showPhotoSourceDialogAsync(), []);
}
